import tealium, { ActionType } from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

export const pageViews = {
  searchPageLoaded: ActionType.VIEW,
  searchPredicted: ActionType.VIEW,
  searchRedirect: ActionType.VIEW
};

const defaultData: IDataLayer = {
  searchIRBannerDisplayed: {
    event_name: 'dtigimagesearch',
    event_category: 'onsite search',
    event_action: 'image search banner',
    event_label: 'displayed'
  },

  searchIRBannerClicked: {
    event_name: 'dtigimagesearch',
    event_category: 'onsite search',
    event_action: 'image search banner',
    event_label: 'clicked'
  },

  searchIRTryAgainClicked: {
    event_name: 'dtigimagesearch',
    event_category: 'onsite search',
    event_action: 'try again button',
    event_label: 'clicked'
  },

  searchAllResultsSelected: {
    event_name: 'onsite_search',
    event_category: 'onsite search',
    event_action: 'standard search',
    event_label: null, // '<search term>'
    event_value: null, // '<number of returned results>'
    event_noninteraction: false,
    search_keyword: null, // '<search term>'
    search_type: 'standard search',
    number_of_on_site_search_results: null, // '<number of returned results>'
    number_of_on_site_searches: 1
  },

  searchOneResultSelected: {
    event_name: 'onsite_search',
    event_category: 'onsite search',
    event_action: 'type ahead',
    event_label: null, // '<search term>'
    event_noninteraction: false,
    search_keyword: null, // '<search term>'
    product_sku: null, // '<product sku'>
    product_id: null, // '<product id'>
    product_name: null, // '<prodcut name>'
    search_type: 'standard search'
  },

  searchResultsRedirect: {
    event_name: 'onsite_search',
    event_category: 'onsite search',
    event_action: 'redirect',
    event_label: null, // '<search term>'
    event_noninteraction: false,
    search_keyword: null, // '<search term>'
    search_type: 'redirect',
    number_of_on_site_searches: 1
  },

  searchPageLoaded: {
    page_name: 'search',
    page_template: 'search',
    page_type: 'search',
    platform: 'modernized',
    product_source: null, // '<product_source_api>',
    search_keyword: null, // '<search term>'
    search_type: 'standard',
    search_results: null, // '<number of results>',
    Number_of_On_Site_Searches: 1,
    site_search_results_found: null // '<if search was an empty search or not>',
  },

  searchPredicted: {
    page_name: 'search overlay',
    page_template: 'search',
    page_type: 'search',
    platform: 'modernized',
    product_source: null, // '<product_source_api>'
    search_keyword: null, // '<search term>'
    search_type: 'overlay',
    search_results: null, // '<number of results>',
    Number_of_On_Site_Searches: 1,
    site_search_results_found: null, // '<if search was an empty search or not>'
    location: null // <location of overlay
  },

  searchOverlayDisplayed: {
    event_name: 'search_overlay_open',
    event_action: 'view_search',
    event_category: 'search',
    event_label: 'view_search_overlay'
  }
};

function trackSearchPageLoaded(_: string, eventData: IDataLayer = {}) {
  if (eventData) {
    const analytics_datalayer = eventData['analytics-datalayer'];
    if (analytics_datalayer?.search_keyword) {
      if (analytics_datalayer?.product_impression_id) {
        analytics_datalayer.product_impression_position =
          analytics_datalayer.product_impression_id.map((_, i) => i + 1);
      }
      tealium.dataLayer.update(analytics_datalayer);
      tealium.evtView({
        ...analytics_datalayer,
        ...defaultData['searchPageLoaded'],
        ...eventData['analytics-datalayer']
      });
    }
  }
}

function trackSearchPredicted(_: string, eventData: IDataLayer = {}) {
  if (eventData) {
    if (eventData?.search_keyword) {
      if (eventData?.product_impression_id) {
        eventData.product_impression_position = eventData.product_impression_id.map(
          (_, i) => i + 1
        );
      }
      eventData.location =
        location.pathname + '?search=' + eventData.search_keyword + '&searchtype=overlay';
      window.page_data['analytics-datalayer'].overlay_datalayer = eventData;
      tealium.evtView({ ...defaultData['searchPredicted'], ...eventData });
    }
  }
}

function trackSearchOverlayDisplayed(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData['searchOverlayDisplayed'], ...eventData });
}

// Registering event handlers directly
registerAnalyticsEventHandler('searchPageLoaded', trackSearchPageLoaded);
registerAnalyticsEventHandler('searchPredicted', trackSearchPredicted);
registerAnalyticsEventHandler('searchOverlayDisplayed', trackSearchOverlayDisplayed);
